
function formatDateRange(startDate, endDate) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const sDay = startDate.getDate();
    const sMonth = months[startDate.getMonth()];
    const sYear = startDate.getFullYear();

    const eDay = endDate.getDate();
    const eMonth = months[endDate.getMonth()];
    const eYear = endDate.getFullYear();

        if (sMonth === eMonth) {
        // 同年同月
        return `${sMonth} ${sDay} - ${eDay}`;
        } else {
        // 同年不同月
        return `${sMonth} ${sDay} - ${eMonth} ${eDay}`;
        }
}



  class PdtCardShipInfo extends HTMLElement {
    constructor() {
      super();

    }

    connectedCallback() {
      requestAnimationFrame(() => {
            
            console.log("this",this);
            let normal_dom = this.querySelector("[normal]");
            let fast_dom = this.querySelector("[fast]");
            console.log("normal_dom",normal_dom);
            let normal_start = new Date();
            normal_start.setDate(new Date().getDate()+3);
            let normal_end = new Date();
            normal_end.setDate(new Date().getDate()+5);
            normal_dom.innerText = formatDateRange(normal_start,normal_end);

            let fast_start = new Date();
            fast_start.setDate(new Date().getDate()+2);
            let fast_end = new Date();
            fast_end.setDate(new Date().getDate()+4);
            fast_dom.innerText = formatDateRange(fast_start,fast_end);
      });

    }

  }

  // 注册自定义元素 <my-element>
  customElements.define('pdt-card-ship-info', PdtCardShipInfo);


  class PdtCardSaleInfo extends HTMLElement {
    constructor() {
      super();

    }

    connectedCallback() {
      requestAnimationFrame(() => {
            this.addEventListener("click",()=>{
                document.querySelector(".FCcfBtn").click();
            })
      });

    }

  }

  // 注册自定义元素 <my-element>
  customElements.define('pdt-card-sale-info', PdtCardSaleInfo);

